import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import drawItActions from 'redux/actions/drawItActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import pickerSelector from 'redux/selectors/picker/picker_selector'

import Picker from 'views/picker/main_picker/picker'

class ReferenceMediaFilePicker extends PureComponent {

	constructor(props) {
		super(props)
		this.onFilePicked = this.onFilePicked.bind(this)
	}

	onFilePicked(file, acceptedFiles) {
		this.props.actions.filePicked(acceptedFiles, file, this.props.questionId, false)
	}

	render() {
		return (
			<Picker
				onFilesPicked={this.onFilePicked}
				onFileError={this.props.actions.fileError}
				closeHandler={this.props.actions.closeModal}
				pickerType={this.props.pickerType}
				googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
			/>
		)
	}
}

ReferenceMediaFilePicker.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return pickerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: drawItActions.cancelReferenceMediaPicker,
		filePicked: drawItActions.uploadReferenceMedia,
		fileError: drawItActions.uploadReferenceMediaError,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceMediaFilePicker)

export { ReferenceMediaFilePicker }
